import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "What Amazon domains are supported?",
    a: "The plugin supports amazon.com, amazon.in, and amazon.co.uk out of the box. Each domain has tailored CSS selectors for reliable data extraction.",
  },
  {
    q: "Does this plugin use the Amazon Product Advertising API?",
    a: "No. The plugin scrapes public product pages directly. No API keys are required. It uses rotating User-Agent strings and exponential backoff to minimize blocking.",
  },
  {
    q: "How often does product data sync?",
    a: "Every 8 hours by default via WP-Cron. You can also trigger syncs manually from the admin dashboard or via the REST API endpoint. Server-cron setup is recommended for production sites.",
  },
  {
    q: "What happens if Amazon blocks a request?",
    a: "The scraper retries up to 3 times with exponential backoff and random delays. If all retries fail, the previously cached data is preserved. Products are never left without data — the frontend always shows the last successful snapshot.",
  },
  {
    q: "Can I use this with page builders like Elementor?",
    a: "Yes. The shortcodes [affiliate_product] and [affiliate_grid] work in any page builder that supports WordPress shortcodes. Elementor, Beaver Builder, and Divi all support this.",
  },
  {
    q: "Is price history included?",
    a: "Yes. Price history tracking is enabled by default and stores up to 90 data points per product (approximately 30 days at 8-hour intervals). A sparkline chart is displayed on each product card.",
  },
  {
    q: "What PHP version is required?",
    a: "PHP 7.4 or higher. The plugin uses DOMDocument for HTML parsing, which is included in most PHP installations.",
  },
  {
    q: "How do I add my affiliate tag?",
    a: "Go to Amazon Products > Settings in your WordPress admin. Enter your tag in the 'Affiliate Tag' field (e.g., 'yourtag-20'). The tag is automatically appended to all product URLs.",
  },
  {
    q: "Does the disclaimer appear automatically?",
    a: "Yes. The Amazon Associate disclaimer appears automatically on every product card and grid output. You can customize the disclaimer text in the plugin settings.",
  },
  {
    q: "What data is stored for each product?",
    a: "Title, price (formatted and raw), image URL, rating, availability status, ASIN, source URL, affiliate URL, domain, currency, sync status, last synced timestamp, price history, and any error messages.",
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F9FAFB]"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-flex items-center gap-2 bg-[#FF7300]/10 text-[#FF7300] px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            FAQ
          </span>
          <h2 className="font-display font-extrabold text-[#09090B] text-3xl sm:text-4xl tracking-tight mb-4">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-white border border-[#E4E4E7] rounded-lg px-6 data-[state=open]:border-[#09090B] transition-colors"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-sm font-semibold text-[#09090B] hover:text-[#FF7300] hover:no-underline py-4">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#52525B] leading-relaxed pb-4">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
